// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kykX","left":"styles_left__1WqHA","desktopActions":"styles_desktopActions__3wRjG","title":"styles_title__pkDGW"};